// extracted by mini-css-extract-plugin
export default {"overrideWidth":"AssessmentReport_overrideWidth__73tzU"};